import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '@/services/api';
import './styles.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [ssoUrl, setSsoUrl] = useState<string | null>(null);
  const { login, error, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const config = await api.public.getAppConfig();
        if (config && config.wordpressSsoUrl) {
          setSsoUrl(config.wordpressSsoUrl);
        }
      } catch (err) {
        console.error('Failed to fetch SSO config:', err);
      }
    };

    fetchConfig();
  }, []);

  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err) {
      // Error is already handled in AuthContext, but we catch it here
      // to prevent the navigation from happening on failure.
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-form-card">
        <h1 className="login-title">Sign In</h1>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
          <div className="sso-separator">
            <span>or</span>
          </div>
          <a
            href={ssoUrl || '#'}
            className={`sso-button ${!ssoUrl ? 'disabled' : ''}`}
            aria-disabled={!ssoUrl}
          >
            Login with stsai.pl
          </a>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
